export const ROUTE_PATH_PUBLIC_STATS = "/public-stats";
export const ROUTE_PATH_CARD_STATS = "/public-stats";
export const ROUTE_PATH_MASTER_STATS = "/public-stats/masters";

export const EOS_PATH_SUFFIX = "/end-of-season";
export const API_KEY = 'AIzaSyCDewMN1O6CBrfHbmyJwQ9tmPPCEm6IItQ';   //Google API
export const SHEET_ID = '1FtctI6HWI6aKIBZQ-uCtWrQwKXEIfXNh55EAU4DWWGQ';